import type { ReactNode } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { RouteCatalogProvider } from '@features/navigation/components/RouteCatalogContext'
import AuthBridge from './features/auth/components/AuthBridge'
import ConfigurationController from './features/settings/components/ConfigurationController'
import SettingsResolutionSyncController from './features/settings/components/SettingsResolutionSyncController'
import ThemeController from './features/settings/components/ThemeController'
import { ToastProvider } from '@features/shared/components/Toast'
import { ErrorBoundary } from './features/shared/components/ErrorBoundary'
import { RouteNavigationController } from './features/navigation/components/RouteNavigationController'
import Loading from '@features/shared/components/Loading'
import { AppUpdateController } from '@features/shared/components/AppUpdateController'

// The crash screen keeps the theme the app was showing.
const themeFallback = (fallback: ReactNode) => <ThemeController>{fallback}</ThemeController>

function App() {
  return (
    <>
      {/* Outside the error boundary: an update's screen and reload outlast a crash. */}
      <AppUpdateController routeChanges={router} />
      <ToastProvider>
        <ErrorBoundary wrapFallback={themeFallback}>
          <AuthBridge />
          <ConfigurationController loadingFallback={<Loading />}>
            <ThemeController>
              <SettingsResolutionSyncController />
              <RouteNavigationController />
              {/* The route picker reads the router's own routes. */}
              <RouteCatalogProvider routes={router.routes}>
                <RouterProvider router={router} />
              </RouteCatalogProvider>
            </ThemeController>
          </ConfigurationController>
        </ErrorBoundary>
      </ToastProvider>
    </>
  )
}

export default App
